
try {
  process.dlopen(module, __dirname + require("path").sep + __webpack_public_path__ + "e229c1b0266a376aca04e7a37697b1b4.node");
} catch (error) {
  throw new Error('node-loader:\n' + error);
}
